'use strict';

require('@babel/polyfill');
window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');
var tagManager = require('int_googletags/tagManager');

$(document).ready(function () {
    if (tagManager && window.pageContext) {
        tagManager.init(window.pageContext.ns);
    }

    processInclude(require('base/components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('base/components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base/components/search'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('../js/slick/slick'));
});

require('base/thirdParty/bootstrap');
require('base/components/spinner');
require('./thirdParty/jquery.inputmask.min');
require('slick-carousel/slick/slick.min.js');
